exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zIndexTop{position:relative}.zIndexTop .ivu-drawer-body{padding-top:0}", ""]);

// exports
